<template>
    <footer class="footer"
            :class="{[`footer-${type}`]: type}"
            :data-background-color="backgroundColor">
        <div class="container">
            <nav>
                <ul>
                    <li>
                        <a href="https://www.code4educom">
                            Code4Edu
                        </a>
                    </li>
                    <li>
                        <a href="https://www.sinnif.com">
                            Sinnif.com
                        </a>
                    </li>
                    <li>
                        <a href="https://www.ankaradil.com">
                            Ankara Dil Akademisi
                        </a>
                    </li>
                </ul>
            </nav>
            <div class="copyright">
                &copy; {{year}},
                <a href="https:///www.code4edu.com" target="_blank">code4Edu</a>.
            </div>
        </div>
    </footer>
</template>
<script>
  export default {
    props: {
      backgroundColor: String,
      type: String
    },
    data(){
      return {
        year: new Date().getFullYear()
      }
    }
  }
</script>
<style>
</style>
